import { createPartnerAdminApiStore } from '@/api'

const apiStore = createPartnerAdminApiStore([
  {
    action: '_settlementMonthly',
    path: `v2/settlement/monthly`,
    method: 'get',
    cacheable: false
  },
  {
    action: '_settlementDaily',
    path: 'v2/settlement/daily',
    method: 'get',
    cacheable: false
  }
])

const PAGE_DATA = () => {
  return {
    pageIndex: 1,
    pageCount: 30,
    format: ''
  }
}

const SEARCH_DATA = () => {
  return {
    begin: '',
    end: '',
    year: '',
    months: '',
  }
}

const INIT_DATA = () => {
  return Object.assign({}, SEARCH_DATA(), PAGE_DATA())
}

export default {
  namespaced: true,
  mixins: [apiStore],
  state: {
    listParams: INIT_DATA()
  },
  actions: {
    settlementMonthly ({ state, dispatch, commit }, params) {
      return dispatch('_settlementMonthly', { params: Object.assign({}, state.listParams, params) })
    },
    settlementDaily ({ state, dispatch, commit }, params) {
      return dispatch('_settlementDaily', { params: Object.assign({}, state.listParams, params) })
    }
  },
  mutations: {
    SET_SEARCH_PARAMS (state, params) {
      state.listParams.begin = params.begin
      state.listParams.end = params.end
      state.listParams.year = params.year
      state.listParams.months = params.months
    },
    SET_PAGE_PARAMS (state, params) {
      state.listParams.pageIndex = params.pageIndex
      state.listParams.pageCount = params.pageCount
      state.listParams.format = params.format
    },
    INIT (state) {
      state.listParams = INIT_DATA()
    }
  },
  getters: {
    listParams: (state, getters) => {
      return state.listParams
    }
  }
}
